import React, { useState, useEffect } from 'react';
import DataTableComponent from "../../../../../../../Util/DataTable/DataTable";
import axiosApi from './../../../../../../../core/interceptor/interceptor';
import { config } from '../../../../../../../config';
import { loadColumns } from "../../../../../../../Util/helper";
import WarningDialogue from "../../../../../../../Util/WarningDialogue";

export default function Archive(props) {
  const [msgDetail, setMsgDtail] = useState({
    direction: 'desc',
    sort_column: '',
    page: 1,
    limit: 50,
  });


  const [archiveData, setArchiveData] = useState([]);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [textId, setTextId] = useState(0);
  const columns = [
    {
      name: 'Subject',
      selector: 'subject',
    },
    {
      name: 'Num Recipients',
      selector: 'user_ids',
      type: 'count',
      sortable: false
    },
    {
      name: 'Captains Only',
      sortable: false,
    },
    {
      name: 'Date Sent',
      selector: 'created_at',
      type: 'date',
    },
    {
      name: 'Time Sent',
      selector: 'created_at',
      type: 'time',
    }
  ];

  const textColumns = [
    {
      name: 'Message',
      selector: 'body',
    },
    {
      name: 'Num Recipients',
      selector: 'user_ids',
      type: 'count',
      sortable: false
    },
    {
      name: 'Scheduled Date',
      selector: 'schedule_date_time_tz',
      type: 'datetime',
    },
    {
      name: 'Created At',
      selector: 'created_at',
      type: 'datetime',
    },
    {
      name: 'Action',
      selector: 'table_action',
      sortable: false,
      mode: 'action',
      type: 'table_action',
      actionHandler: function (e) {
        if (new Date(e.schedule_date_time_tz) > new Date()) {
          setTextId(e?.id);
          setOpenWarningPopup(true);
        }

      },
      style: { width: '50%' }
    },
  ];

  const deleteMassText = () => {
    axiosApi.delete(`${config.apiUrl}/messages/${textId}`)
      .then((res) => {
        getUserMessages();
        setOpenWarningPopup(false);
      })
      .catch(() => {
        setOpenWarningPopup(false);
      })
  }

  const [totalPage, setTotalPage] = useState(0);

  const getUserMessages = () => {
    axiosApi.get(`${config.apiUrl}/messages/${props.type}`, { params: msgDetail })
      .then((response) => {
        setArchiveData(response.data.data);
        setTotalPage(response.data.total);
      })
      .catch((err) => {

      });
  }

  const handleChange = (e) => {
    let stateFunc = null;
    if (e.type === 'sort') {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.value,
        'direction': e.target.direction,
      })
    } else {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.value,
      })
    }
    setMsgDtail(stateFunc);
  }

  useEffect(() => {
    getUserMessages();
    //eslint-disable-next-line
  }, [
    msgDetail.page,
    msgDetail.limit,
    msgDetail.direction,
    msgDetail.sort_column
  ])

  return (
    <>
      <div className="table-wrapper">
        <div className="dataTable">
          <DataTableComponent key="table-admin-users"
            type={props.type}
            data={archiveData}
            columns={loadColumns({ columns: props.type === 'text' ? textColumns : columns })}
            onFilterChange={handleChange}
            totalPage={totalPage}
            hideArchBtn={(e) => props.hideArchBtn(e)} />
        </div>
      </div>
      <WarningDialogue
        isOpen={openWarningPopup}
        header={'Warning'}
        description={'Are you sure you want to delete this mass text?'}
        action={deleteMassText}
        onClose={() => setOpenWarningPopup(false)}
      />
    </>
  );
}